import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {modifyPageLayoutComponents, EditorFooter as pageFooterTemplate} from '../PageLayout';
import template from '../../templates/FabricatorProfileContent.rt';
import pageHeaderTemplate from '../../templates/FabricatorProfilePageHeader.rt';
import * as actions from '../../actions';
import * as editorNames from '../../constants/editorNames';
import {selectItemUpdates} from '../../selectors';
import _ from 'lodash';

function mapStateToProps(state, props) {
  const {auth} = state;
  let fabricator = actions.getFabricatorFromState(state);
  let updatedFabricator = selectItemUpdates(state, fabricator);
  return {
    auth,
    fabricator,
    updatedFabricator,
    editorTimeouts: []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoadEditor: () => dispatch(actions.loadEditor(editorNames.FABRICATOR_PROFILE)),
    onUnloadEditor: () => dispatch(actions.unloadEditor()),
    onFetchFabricatorInfo: () => dispatch(actions.fetchStones()).catch(console.log),
    onUpdateTransientField: (key, value) => dispatch(actions.updateFabricatorTransientField(key, value)),
    getStoreState: (callback) => dispatch(actions.requestState(callback)),
    authGoogleCalendar: () => dispatch(actions.authGoogleCalendar())
      .then((response) => {
        let fabricator = actions.getFabricatorFromState(response.state);
        const {access_token, client_id, expires_at, expires_in, issued_at, response_type, scope, token_type} = response.result;
        let result = JSON.stringify({
          access_token,
          client_id,
          expires_at,
          expires_in,
          issued_at,
          response_type,
          scope,
          token_type
        });
        dispatch(actions.updateFabricatorTransientField('googleAuthKey', 'oauth_' + fabricator.id));
        dispatch(actions.updateFabricatorTransientField('googleAuthValue', result));
      }).catch(() => {
        dispatch(actions.messageBox_Show(true, 'error', 'An error occurred', 'Unable to authorize Google Calendar Access.'));
      })
  };
}

function getStateFromFabricator(fabricator) {
  return {
    name: fabricator.name || '',
    phone: fabricator.phone || '',
    contactEmail: fabricator.contactEmail || '',
    websiteUrl: fabricator.websiteUrl || '',
    address1: fabricator.address1 || '',
    address2: fabricator.address2 || '',
    city: fabricator.city || '',
    provence: fabricator.provence || '',
    postal: fabricator.postal || '',
    imageUrl: fabricator.imageUrl || ''
  };
}

class fabricatorProfileContent extends Component {
  constructor(props) {
    super(props);

    this.state = getStateFromFabricator({});
  }

  updateFieldValue = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.updateFieldEvent(e.target.id, e);
    const newStateValue = {};
    newStateValue[e.target.id] = e.target.value;
    this.setState(newStateValue);
  }

  componentWillReceiveProps(nextProps) {
    this.props.getStoreState((state) => {
      const {editor} = state;
      let e_updatedItems = editor.updatedItems || [];
      //do not load master fabricator or un-authed fabricator information
      if (nextProps.fabricator.id === nextProps.auth.fabricatorId) {
        //need to merge in pending updates
        const updatedItems = e_updatedItems[nextProps.fabricator.id] || {};
        let updatedFabricator = _.assign({}, nextProps.fabricator, updatedItems);
        this.setState(getStateFromFabricator(updatedFabricator));
      }
    });
  }

  componentWillMount() {
    this.props.onLoadEditor();
    this.props.onFetchFabricatorInfo();
  }

  handleFileSelect = (evt) => {
    const files = evt.target.files; // FileList object

    // Loop through the FileList and render image files as thumbnails.
    let i = 0, f;
    for (; f = files[i]; i++) {
      // Only process image files.
      if (!f.type.match('image.*')) {
        continue;
      }

      this.props.onUpdateTransientField('imageName', f.name);
      const reader = new FileReader();

      // Closure to capture the file information.
      reader.onload = (function (theFile) {
        return function (e) {
          // Render thumbnail.
          this.props.onUpdateTransientField('imageUrl', e.target.result);
          this.setState({imageUrl: e.target.result});

        }.bind(this);
      }.bind(this))(f);

      // Read in the image file as a data URL.
      reader.readAsDataURL(f);
    }
  }

  updateFieldEvent = (key, ev) => {
    const {editorTimeouts} = this.props;
    if (editorTimeouts[key]) {
      window.clearTimeout(editorTimeouts[key]);
      editorTimeouts[key] = null;
    }
    const val = ev.target.value;
    editorTimeouts[key] = window.setTimeout(() => {
      this.props.onUpdateTransientField(key, val)
    }, 500);
  }

  componentWillUnmount() {
    this.props.onUnloadEditor();
  }

  render = template
}

fabricatorProfileContent.propTypes = {
  onLoadEditor: PropTypes.func.isRequired,
  onUnloadEditor: PropTypes.func.isRequired,
  onFetchFabricatorInfo: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const FabricatorProfileLayoutComponents = modifyPageLayoutComponents({
  pageHeader: pageHeaderTemplate,
  content: connector(fabricatorProfileContent),
  pageFooter: connector(pageFooterTemplate)
});
